<template>
    <div>
        <!-- Backdrop mobile -->
        <div v-if="isMobile && isOpen" class="mobile-sidebar-backdrop" @click="closeMobileSidebar" />

        <nav
            id="sidebar1"
            aria-label="Main Navigation"
            :class="{
                'sidebar-minimized w-2': !isOpen && !isMobile,
                'mobile-drawer': isMobile,
                'mobile-drawer-open': isMobile && isOpen,
            }"
            @mouseenter="!isMobile && onSidebarHover()"
            @mouseleave="!isMobile && onSidebarLeave()"
        >
            <div
                id="contentheader1"
                :class="{ '!ppv2-pl-[33px]': isOpen && !isMobile }"
                class="ppv2-p-4 mb-3 position-relative d-flex justify-content-between align-items-center"
            >
                <!-- Logo normal -->
                <img
                    @click="load_page"
                    src="/media/logoplaypro1.png"
                    alt="logo"
                    class="logo-normal"
                    :style="[logoStyle, { cursor: 'pointer' }]"
                />
                <!-- Logo mini (desktop only) -->
                <img
                    v-if="!isMobile"
                    @click="load_page"
                    src="/media/minilogoplaypro.png"
                    alt="logo"
                    class="logo-mini"
                    :style="logoMiniStyle"
                    @mouseenter="onLogoHover"
                />

                <!-- Bouton X pour fermer sur mobile -->
                <div v-if="isMobile" class="mobile-close-btn" @click="closeMobileSidebar">
                    <X :size="20" color="white" />
                </div>

                <!-- Bouton expand - desktop seulement -->
                <div v-if="!isMobile" id="expandBtn" class="expand-btn" :class="expandBtnClasses" @click="toogleMenu">
                    <PanelLeftClose v-if="isOpen" id="svgArrow" color="white" :strokeWidth="1" width="30" height="26" />
                    <PanelLeftOpen
                        v-if="!isOpen && isSidebarHovered"
                        id="svgArrow"
                        color="white"
                        :strokeWidth="1"
                        width="30"
                        height="26"
                    />
                </div>
            </div>
            <hr class="ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-[7%] ppv2-m-0" v-if="isMobile" />

            <div class="filter-section">
                <div class="dropdown-container"></div>
                <ul class="nav-main ppv2-w-full p-2">
                    <li
                        v-for="(item, index) in filteredMenuItems"
                        :key="index"
                        class="nav-main-item"
                        :class="{ opens: isMenuOpen(item, index) }"
                        @click="item.children ? toogleSubMenu($event, index) : null"
                    >
                        <a
                            v-if="!item.children"
                            :href="item.href"
                            class="nav-main-link sidebarLink"
                            :class="{ active: currentRoute === item.currentRoute }"
                            @click="isMobile && closeMobileSidebar()"
                        >
                            <span class="nav-content">
                                <component :is="item.icon" :size="iconSize" />
                                <span class="nav-text">{{ item.label }}</span>
                            </span>
                        </a>

                        <!-- Submenu -->
                        <template v-else>
                            <a
                                @click.prevent=""
                                class="nav-main-link sidebarLink nav-main-link-submenu cursor-pointer"
                                :class="{ active: item.children.some((sub) => isSubActive(sub)) }"
                                data-toggle="submenu"
                                aria-haspopup="true"
                                aria-expanded="true"
                            >
                                <span class="nav-content">
                                    <component :is="item.icon" :size="iconSize" />
                                    <span class="nav-text">{{ item.label }}</span>
                                </span>
                                <ChevronRight :size="iconSize" class="openMe" />
                            </a>

                            <!-- Expanded mode: animated expand/collapse -->
                            <v-expand-transition v-if="isOpen || isMobile">
                                <ul v-show="isMenuOpen(item, index)" class="nav-main-submenu mx-0 px-0">
                                    <li
                                        v-for="(sub, sIndex) in item.children"
                                        :key="sIndex"
                                        v-if="sub.visible"
                                        class="nav-main-item d-flex flex-row w-full !ppv2-mb-0 p-0"
                                    >
                                        <a
                                            :href="sub.href"
                                            class="nav-main-link w-full !ppv2-pl-[60px]"
                                            :class="{ active: isSubActive(sub) }"
                                            @click="isMobile && closeMobileSidebar()"
                                        >
                                            <span class="nav-text">{{ sub.label }}</span>
                                            <!--span
                                                v-if="sub.requiresPlanLevel && currentPlanLevel < sub.requiresPlanLevel"
                                                class="ppv2-ml-2 ppv2-px-2 ppv2-py-[1px] ppv2-rounded-full ppv2-bg-[#7D2DBD] ppv2-text-white ppv2-text-[10px] poppinsSemiBold"
                                            >
                                                {{ $t('sidebar.premium_badge') }}
                                            </span-->
                                        </a>
                                    </li>
                                </ul>
                            </v-expand-transition>

                            <!-- Minimized mode (desktop only) -->
                            <ul
                                v-if="!isOpen && !isMobile"
                                class="nav-main-submenu mx-0 px-0"
                                :style="openMenus.includes(index) ? { top: submenuTop + 'px' } : {}"
                            >
                                <li
                                    v-for="(sub, sIndex) in item.children"
                                    :key="sIndex"
                                    v-if="sub.visible"
                                    class="nav-main-item d-flex flex-row w-full !ppv2-mb-0 p-0"
                                >
                                    <a :href="sub.href" class="nav-main-link w-full" :class="{ active: isSubActive(sub) }">
                                        <span class="nav-text">{{ sub.label }}</span>
                                        <span
                                            v-if="sub.requiresPlanLevel && currentPlanLevel < sub.requiresPlanLevel"
                                            class="ppv2-ml-2 ppv2-px-2 ppv2-py-[1px] ppv2-rounded-full ppv2-bg-[#7D2DBD] ppv2-text-white ppv2-text-[10px] poppinsSemiBold"
                                        >
                                            {{ $t('sidebar.premium_badge') }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </template>
                    </li>
                </ul>
            </div>
            <footer class="sidebar-footer" :class="{ 'sidebar-footer-minimized': !isOpen && !isMobile }">
                <div class="sidebar-help" @click="handleHelp()">
                    <HelpCircle :size="19" />
                    <span v-show="isOpen || isMobile" class="sidebar-help-text">{{ $t('sidebar.support') }}</span>
                </div>
                <div v-show="isOpen || isMobile" class="sidebar-version">Version {{ appVersion }}</div>
            </footer>
        </nav>
    </div>
</template>

<script>
import { EventBus } from '../../eventBus.js'
import {
    PanelLeftClose,
    PanelLeftOpen,
    ChartLine,
    CalendarDays,
    Computer,
    ShoppingCart,
    Megaphone,
    Settings,
    ChevronRight,
    Users,
    ChartNoAxesCombined,
    X,
    HelpCircle,
} from 'lucide-vue'

export default {
    props: [
        'initialRoute',
        'establishmentId',
        'minimized',
        'planLevel',
        'permissionLevels',
        'permissionsGivenBySuperAdmin',
        'isSuperAdmin',
        'canConsultTableauBoard',
        'canConsultReservations',
        'canConsultOrder',
        'canConsultGroupsCustomers',
        'canConsultGiftCards',
        'canConsultUndatedTickets',
        'canConsultDevis',
        'canConsultInvoice',
        'canConsultAnnonce',
        'canConsultPromosCode',
        'canConsultAbandonedCart',
        'canConsultCompagne',
        'canModifyMailAuto',
        'canConsultNotificationPush',
        'canConsultBlog',
        'canConsultPlanningStaff',
        'canConsultUsers',
        'canConsultRoles',
        'canDownloadDocumentsComptables',
        'canDownloadDocumentsOperationelle',
        'canConsultEstablishmentSettings',
        'canConsultWebsiteSetting',
        'canViewExperience',
        'canViewForfaits',
        'canViewAbonnement',
        'canViewFormules',
        'canConsultCategoryExperience',
        'canConsultInstallations',
        'canConsultMateriel',
        'canConsultWidgets',
        'canViewVenteAdditionnelle',
        'canViewProductFood',
        'canConsultModelDevis',
        'canConsultDemandeDevis',
        'canViewPos',
        'canConsultIntegration',
        'canViewApiKey',
        'anyRoleAdminManager',
        'version',
    ],
    data() {
        const isForcedMinimized = this.minimized === true || this.minimized === 'true'
        const isMobileScreen = typeof window !== 'undefined' && window.innerWidth <= 768
        const isSmallScreen = typeof window !== 'undefined' && window.innerWidth <= 1470
        return {
            isOpen: isForcedMinimized || isSmallScreen ? false : true,
            isMobile: isMobileScreen,
            currentRoute: this.initialRoute,
            isOpenSub: false,
            isSidebarHovered: false,
            openMenus: [],
            submenuTop: 0,
            isLogoHovered: false,
            pageMarketingList: [
                'getPromotions',
                'createPromotion',
                'editPromotion',
                'notifications.index',
                'newsletters.index',
                'notifications.create',
                'v3_blogs_index',
                'v3_add_blog',
                'v3_edit_blog',
                'editViewMailCustom',
                'getPromotionsV3',
            ],
            subItemMarketingList: ['getPromotions', 'getPromotionsV3', 'createPromotion', 'editPromotion', 'getAbandonedCartV3'],
            menuSales: ['getInvoicesV2', 'getDevis', 'getCustomersBOV2'],
            iconSize: 18, // Taille par défaut des icônes,
            menuItems: [],
            resizeSideBar: false,
        }
    },
    computed: {
        /**
         * Version affichée dans le footer du menu (fallback si le blade ne la passe pas).
         */
        appVersion() {
            return this.version || '3.8.0'
        },
        /**
         * Check if user has access to a permission based on:
         * 1. User has the permission (canXxx prop is true)
         * 2. Tenant's plan_level >= permission's min_plan_level
         */
        currentPlanLevel() {
            const level = parseInt(this.planLevel, 10)
            return isNaN(level) ? 0 : level
        },
        allMenuItems() {
            // Helper to check permission + plan level
            const checkAccess = (hasPermission, permissionName) => {
                const hasPerm = hasPermission === true || hasPermission === 'true'
                if (!hasPerm) return false
                // Super-admin bypasse la vérification du plan level
                if (this.isSuperAdmin === true || this.isSuperAdmin === 'true') return true
                // Permission donnée par super-admin (override du plan level)
                if (this.permissionsGivenBySuperAdmin && this.permissionsGivenBySuperAdmin.includes(permissionName)) {
                    return true
                }
                if (!this.permissionLevels) return true
                const minLevel = this.permissionLevels[permissionName]
                if (minLevel === undefined || minLevel === null) return true
                return this.currentPlanLevel >= parseInt(minLevel, 10)
            }

            return [
                {
                    label: this.$t('sidebar.dashboard'),
                    icon: 'ChartLine',
                    href: '/back-office',
                    currentRoute: 'adminHome',
                    visible:
                        checkAccess(this.canConsultTableauBoard, 'Voir le tableau de bord opérationnel') ||
                        checkAccess(this.canConsultTableauBoard, 'Voir le tableau de bord financier'),
                },
                {
                    label: this.$t('sidebar.calendar'),
                    icon: 'CalendarDays',
                    href: '/back-office/planning',
                    currentRoute: 'adminPlanning',
                    visible: checkAccess(this.canConsultReservations, 'Voir les réservations'),
                },
                {
                    label: this.$t('sidebar.nomad_checkout'),
                    icon: 'Computer',
                    href: '/back-office/v3/caisse',
                    currentRoute: 'getCheckouts',
                    visible: checkAccess(this.canConsultOrder, 'Voir les commandes'),
                },
                // Caisse V3 is BETA — intentionally NOT in the menu. Accessed manually via
                // /back-office/v3/caisse (optionally with ?order=ID). The legacy caisse above stays the menu entry.
                {
                    label: this.$t('sidebar.sales'),
                    icon: 'ShoppingCart',
                    visible:
                        checkAccess(this.canConsultCustomer, 'Consulter les clients') ||
                        checkAccess(this.canConsultOrder, 'Voir les commandes') ||
                        checkAccess(this.canConsultDevis, 'Voir les devis') ||
                        checkAccess(this.canConsultInvoice, 'Voir les factures'),
                    children: [
                        {
                            label: this.$t('sidebar.customers'),
                            href: '/back-office/v3/customer',
                            currentRoute: 'getCustomersBOV3',
                            visible:
                                checkAccess(this.canConsultCustomer, 'Consulter les clients') ||
                                checkAccess(this.canConsultGroupsCustomers, 'Consulter les groupes clients') ||
                                checkAccess(this.canConsultGiftCards, 'Consulter les bons cadeaux') ||
                                checkAccess(this.canConsultUndatedTickets, 'Consulter les billets non datés') ||
                                checkAccess(this.canViewForfaits, 'Voir les forfaits') ||
                                checkAccess(this.canViewAbonnement, 'Voir les abonnements'),
                        },
                        {
                            label: this.$t('sidebar.orders'),
                            href: '/back-office/invoices-en-attente',
                            currentRoute: 'getInvoicesEnAttente',
                            visible: checkAccess(this.canConsultOrder, 'Voir les commandes'),
                        },
                        {
                            label: this.$t('sidebar.quotes'),
                            href: '/back-office/devis',
                            currentRoute: 'getDevis',
                            visible: checkAccess(this.canConsultDevis, 'Voir les devis'),
                        },
                        {
                            label: this.$t('sidebar.invoices'),
                            href: '/back-office/invoices-v3',
                            currentRoute: 'getInvoicesV3',
                            visible: checkAccess(this.canConsultInvoice, 'Voir les factures'),
                        },
                    ],
                },
                {
                    label: this.$t('sidebar.marketing'),
                    icon: 'Megaphone',
                    visible:
                        checkAccess(this.canConsultAnnonce, 'Voir les annonces') ||
                        checkAccess(this.canConsultPromosCode, 'Voir les codes promo') ||
                        checkAccess(this.canConsultAbandonedCart, 'Relance des paniers abandonnés') ||
                        checkAccess(this.canConsultCompagne, 'Voir les campagnes') ||
                        checkAccess(this.canModifyMailAuto, 'Modifier les mails automatiques') ||
                        checkAccess(this.canConsultNotificationPush, 'Voir les notifications'),
                    children: [
                        {
                            label: this.$t('sidebar.annonces'),
                            href: '/back-office/v3/annonce',
                            currentRoute: 'annonce.index',
                            visible: checkAccess(this.canConsultAnnonce, 'Voir les annonces'),
                        },
                        {
                            label: this.$t('sidebar.promo_codes'),
                            href: '/back-office/v3/promotions',
                            currentRoute: 'getPromotionsV3',
                            visible: checkAccess(this.canConsultPromosCode, 'Voir les codes promo'),
                        },
                        /*{
                            label: this.$t('sidebar.newsletters'),
                            href: '/back-office/communications/newsletters',
                            currentRoute: 'newsletters.index',
                            visible: checkAccess(this.canConsultCompagne, 'Voir les campagnes'),
                        },*/
                        {
                            label: this.$t('sidebar.auto_mails'),
                            href: `/back-office/v3/mailcustom/${this.establishmentId || 1}/edit`,
                            currentRoute: 'mailcustom.v3.edit',
                            visible: checkAccess(this.canModifyMailAuto, 'Modifier les mails automatiques'),
                        },
                        {
                            label: this.$t('sidebar.abandoned_cart'),
                            href: '/back-office/v3/abandoned-cart',
                            currentRoute: 'getAbandonedCartV3',
                            // L'entrée reste VISIBLE hors Premium (min_plan_level de la permission
                            // vaut 0) : le badge signale l'offre requise sans masquer la découverte.
                            requiresPlanLevel: 3,
                            visible: checkAccess(this.canConsultAbandonedCart, 'Relance des paniers abandonnés'),
                        },
                        {
                            label: this.$t('sidebar.push_notifications'),
                            href: '/back-office/v3/communications/notifications',
                            currentRoute: 'v3.notifications.index',
                            visible: checkAccess(this.canConsultNotificationPush, 'Voir les notifications'),
                        },
                        {
                            label: this.$t('sidebar.blog'),
                            href: '/back-office/v3/blogs',
                            currentRoute: 'v3_blogs_index',
                            visible: checkAccess(this.canConsultBlog, 'Voir les articles'),
                        },
                    ],
                },
                {
                    label: this.$t('sidebar.team'),
                    icon: 'Users',
                    visible: true,
                    children: [
                        {
                            label: this.$t('sidebar.planning'),
                            href: '/back-office/v3/planning/staffs',
                            currentRoute: 'bo.planning.v3.staffs',
                            visible: checkAccess(this.canConsultPlanningStaff, 'Voir le planning'),
                        },
                        {
                            label: this.$t('sidebar.users'),
                            href: '/back-office/v3/staffs',
                            currentRoute: 'indextaffsV3',
                            visible: checkAccess(this.canConsultUsers, 'Voir les utilisateurs'),
                        },
                        {
                            label: this.$t('sidebar.roles_access'),
                            href: '/back-office/v3/roles',
                            currentRoute: 'roles.v3.index',
                            visible: checkAccess(this.canConsultRoles, 'Voir les rôles'),
                        },
                        {
                            label: this.$t('sidebar.rewards'),
                            href: '/back-office/gamification',
                            currentRoute: 'GamificationViewAll',
                            visible: false, // Hidden for now, will be back in a few months  this.anyRoleAdminManager === true || this.anyRoleAdminManager === 'true',
                        },
                    ],
                },
                {
                    label: this.$t('sidebar.accounting'),
                    icon: 'ChartNoAxesCombined',
                    href: '/back-office/v3/export',
                    currentRoute: 'getExportBOV3',
                    visible:
                        checkAccess(this.canDownloadDocumentsComptables, 'Télécharger les documents comptables') ||
                        checkAccess(this.canDownloadDocumentsOperationelle, 'Télécharger les documents opérationnels'),
                },
                {
                    label: this.$t('sidebar.settings'),
                    icon: 'Settings',
                    visible: true,
                    children: [
                        {
                            label: this.$t('sidebar.establishment'),
                            href: '/back-office/v2/establishment/1/edit',
                            currentRoute: 'editViewEstablishmentV2',
                            visible: checkAccess(this.canConsultEstablishmentSettings, 'Voir les paramètres'),
                        },
                        {
                            label: this.$t('sidebar.website'),
                            href: '/back-office/v3/website-settings',
                            currentRoute: 'websiteSettingsV3',
                            visible: checkAccess(this.canConsultWebsiteSetting, 'Voir les paramètres du site Internet'),
                        },
                        {
                            label: this.$t('sidebar.experiences'),
                            href: '/back-office/v3/experience',
                            currentRoute: 'indexViewExperienceV3',
                            visible:
                                checkAccess(this.canViewExperience, 'Voir les expériences') ||
                                checkAccess(this.canViewForfaits, 'Voir les forfaits') ||
                                checkAccess(this.canViewAbonnement, 'Voir les abonnements') ||
                                checkAccess(this.canViewFormules, 'Voir les formules combinées') ||
                                checkAccess(this.canConsultCategoryExperience, "Voir les catégories d'expériences"),
                        },
                        {
                            label: this.$t('sidebar.resource'),
                            href: this.canConsultInstallations
                                ? '/back-office/v3/resource?tab=installations'
                                : '/back-office/v3/resource?tab=equipements',
                            currentRoute: 'indexViewResourceV3',
                            visible:
                                checkAccess(this.canConsultInstallations, 'Voir les installations') ||
                                checkAccess(this.canConsultMateriel, 'Voir les matériels'),
                        },
                        {
                            label: this.$t('sidebar.widgets'),
                            href: '/back-office/v3/widgets',
                            currentRoute: 'widgets.indexV3',
                            visible: checkAccess(this.canConsultWidgets, 'Accéder aux widgets'),
                        },
                        {
                            label: this.$t('sidebar.products'),
                            href: '/back-office/v3/product',
                            currentRoute: 'indexViewProductV3',
                            visible: checkAccess(this.canViewVenteAdditionnelle, 'Voir les produits additionnels'),
                        },
                        {
                            label: this.$t('sidebar.restoration'),
                            href: '/back-office/v3/food',
                            currentRoute: 'indexViewFoodV3',
                            // Pages satellites qui gardent « Restauration » actif sans entrée de menu dédiée
                            altRoutes: ['stockMovementsViewFoodV3'],
                            visible: checkAccess(this.canViewProductFood, 'Consulter les produits'),
                        },
                        {
                            label: this.$t('sidebar.tables_qr_codes'),
                            href: '/back-office/v3/food?tab=tables',
                            tab: 'tables',
                            currentRoute: 'indexViewFoodV3',
                            visible: checkAccess(this.canViewProductFood, 'Consulter les produits'),
                        },
                        /*{
                            label: this.$t('sidebar.quote_templates'),
                            href: '/back-office/v2/model_template/index',
                            currentRoute: 'v2_model_temlate_devis.index',
                            visible: checkAccess(this.canConsultModelDevis, 'Voir les modèles'),
                        },*/
                        {
                            label: this.$t('sidebar.formQuestion'),
                            href: '/back-office/v3/formQuestion',
                            currentRoute: 'formQuestion.index',
                            visible: checkAccess(this.canConsultDemandeDevis, 'Consulter un formulaires de demande de devis'),
                        },
                        {
                            label: this.$t('sidebar.pos_devices'),
                            href: '/back-office/v3/pos',
                            currentRoute: 'getPosBOV3',
                            visible: checkAccess(this.canViewPos, 'Voir les points de vente'),
                        },
                        {
                            label: this.$t('sidebar.integration'),
                            href: '/back-office/v3/integration',
                            currentRoute: 'integration.index',
                            visible: checkAccess(this.canConsultIntegration, 'Consulter les intégrations'),
                        },
                        {
                            label: this.$t('sidebar.api'),
                            href: '/back-office/v3/applications',
                            currentRoute: 'adminIndexApplicationV3',
                            visible: checkAccess(this.canViewApiKey, 'Voir les clés'),
                        },
                    ],
                },
            ]
        },
        logoStyle() {
            return {
                width: '113px',
                display: this.isOpen ? 'block' : 'none',
            }
        },
        logoMiniStyle() {
            return {
                width: '32px',
                display: this.isOpen ? 'none' : 'block',
                opacity: this.isLogoHovered ? 0 : 1,
            }
        },
        expandBtnClasses() {
            return {
                'position-absolute ppv2-right-0': this.isOpen,
                'logo-position': !this.isOpen,
                visible: (this.isOpen && this.isSidebarHovered) || (!this.isOpen && this.isLogoHovered),
            }
        },
        filteredMenuItems() {
            // Safety check: Ensure menuItems exists and is an array
            if (!this.menuItems || !Array.isArray(this.menuItems)) {
                return []
            }

            // Recursive function to filter menu items that have children
            const filterVisible = (items) => {
                if (!Array.isArray(items)) return []
                return items
                    .map((item) => {
                        // If it's a leaf node, just check its visibility record
                        if (!item.children) {
                            return item.visible ? item : null
                        }

                        // For items with children, recursively check if any child is visible
                        const visibleChildren = filterVisible(item.children)
                        if (visibleChildren.length > 0) {
                            return { ...item, children: visibleChildren }
                        }

                        return null
                    })
                    .filter(Boolean)
            }

            return filterVisible(this.menuItems)
        },
    },
    watch: {
        initialRoute(val) {
            this.currentRoute = val
        },
        currentRoute: {
            immediate: true,
            handler() {
                this.updateActiveMenu()
            },
        },
        minimized(newVal) {
            const isForcedMinimized = newVal === true || newVal === 'true'
            if (isForcedMinimized) {
                this.isOpen = false
                this.handleResize()
            }
        },
        isOpen(val) {
            this.updateActiveMenu()
        },
        allMenuItems: {
            immediate: true,
            handler(newVal) {
                this.menuItems = JSON.parse(JSON.stringify(newVal))
            },
        },
    },
    created() {
        EventBus.$on('search-updated', this.handleSearch)
    },
    beforeDestroy() {
        EventBus.$off('search-updated', this.handleSearch)
    },
    methods: {
        /**
         * Check if user has access to a permission based on:
         * 1. User has the permission (hasPermission is true)
         * 2. Tenant's plan_level >= permission's min_plan_level
         * @param {boolean|string} hasPermission - Whether user has the permission
         * @param {string} permissionName - The permission name to check min_plan_level
         * @returns {boolean}
         */
        hasAccess(hasPermission, permissionName) {
            // First check if user has the permission
            const hasPerm = hasPermission === true || hasPermission === 'true'
            if (!hasPerm) return false

            // If no permissionLevels provided, allow access (backward compatibility)
            if (!this.permissionLevels) return true

            // Get the min_plan_level for this permission
            const minLevel = this.permissionLevels[permissionName]

            // If permission not found in levels, allow access (default behavior)
            if (minLevel === undefined || minLevel === null) return true

            // Check if tenant's plan_level meets the minimum required
            return this.currentPlanLevel >= parseInt(minLevel, 10)
        },
        toogleMenu() {
            const sidebar = document.querySelector('#sidebar1')
            sidebar.classList.add('transitioning')

            this.isOpen = !this.isOpen
            this.updatePageContainerClasses()

            // Retirer la classe "transitioning" après 300ms (temps de la transition du logo)
            setTimeout(() => {
                sidebar.classList.remove('transitioning')
            }, 300)
        },
        updatePageContainerClasses() {
            const pageContainer = document.querySelector('#page-container')
            const v3Navbar = document.querySelector('#v3_design_navbar')

            if (pageContainer) {
                if (this.isOpen) {
                    pageContainer.className =
                        'ppv2-z-10 sidebar-o sidebar-dark enable-page-overlay side-scroll page-header-fixed side-trans-enabled sidebar-mini open menu'
                } else {
                    pageContainer.className =
                        'ppv2-z-10 sidebar-o sidebar-dark enable-page-overlay side-scroll page-header-fixed side-trans-enabled sidebar-mini paddingLeft'
                }
            }

            if (v3Navbar) {
                if (this.isOpen) {
                    v3Navbar.classList.remove('paddingLeft')
                } else {
                    v3Navbar.classList.add('paddingLeft')
                }
            }
        },
        toogleSubMenu(event, index) {
            // Check if the clicked menu is already open
            const isOpen = this.openMenus.includes(index)

            if (isOpen) {
                // If open, close it
                this.openMenus = this.openMenus.filter((i) => i !== index)
            } else {
                this.openMenus = [index]

                // For minimized sidebar, calculate position
                if (!this.isOpen && event) {
                    const rect = event.currentTarget.getBoundingClientRect()
                    this.submenuTop = rect.top

                    // Ensure submenu doesn't overflow the bottom of the screen
                    this.$nextTick(() => {
                        const submenu = document.querySelector('.sidebar-minimized .nav-main-item.opens .nav-main-submenu')
                        if (submenu) {
                            const submenuHeight = submenu.offsetHeight
                            const viewportHeight = window.innerHeight
                            if (this.submenuTop + submenuHeight > viewportHeight) {
                                // Shift upward
                                this.submenuTop = Math.max(10, viewportHeight - submenuHeight - 20)
                            }
                        }
                    })
                }
            }
            this.saveOpenMenus()
        },
        onSidebarHover() {
            this.isSidebarHovered = true
        },
        onSidebarLeave() {
            this.isSidebarHovered = false
            this.isLogoHovered = false
        },
        onLogoHover() {
            this.isLogoHovered = true
        },
        handleSearch(query) {
            if (!query) {
                this.menuItems = this.allMenuItems
                return
            }

            const q = query.toLowerCase()

            // Recursive function to filter menu items + their children
            const filterItems = (items) => {
                return items
                    .map((item) => {
                        const labelMatch = item.label.toLowerCase().includes(q)

                        // If the item has children, filter them too
                        if (item.children && item.children.length > 0) {
                            const filteredChildren = filterItems(item.children)

                            // Keep parent if it matches OR if any child matches
                            if (labelMatch || filteredChildren.length > 0) {
                                return { ...item, children: filteredChildren }
                            }
                        }
                        // No children: keep only if the label matches
                        else if (labelMatch) {
                            return item
                        }

                        // Otherwise exclude this item
                        return null
                    })
                    .filter(Boolean)
            }

            this.menuItems = filterItems(this.allMenuItems)
        },
        isSubActive(sub) {
            if (!sub) return false
            if (Array.isArray(sub.altRoutes) && sub.altRoutes.includes(this.currentRoute)) return true
            if (sub.tab) {
                if (typeof window !== 'undefined') {
                    const urlParams = new URLSearchParams(window.location.search)
                    return sub.currentRoute === this.currentRoute && urlParams.get('tab') === sub.tab
                }
                return sub.currentRoute === this.currentRoute
            }
            if (sub.href === '/back-office/v3/food') {
                if (typeof window !== 'undefined') {
                    const urlParams = new URLSearchParams(window.location.search)
                    const tab = urlParams.get('tab')
                    return sub.currentRoute === this.currentRoute && (!tab || tab !== 'tables')
                }
                return sub.currentRoute === this.currentRoute
            }
            return sub.currentRoute === this.currentRoute
        },
        isMenuOpen(item, index) {
            // Un menu est ouvert s'il est dans openMenus OU si un de ses enfants correspond à la route actuelle
            if (!item.children) return false
            const isInOpenMenus = this.openMenus.includes(index)

            if (this.isOpen) {
                const hasActiveChild = item.children.some((sub) => this.isSubActive(sub))
                return isInOpenMenus || hasActiveChild
            } else {
                // En mode minimisé, on n'ouvre que si c'est explicitement demandé (click)
                // On ignore hasActiveChild pour permettre la fermeture après navigation
                return isInOpenMenus
            }
        },
        updateActiveMenu() {
            const activeIndex = this.menuItems.findIndex(
                (item) => item.children && item.children.some((sub) => this.isSubActive(sub))
            )

            if (activeIndex !== -1) {
                if (this.isOpen) {
                    this.openMenus = [activeIndex]
                } else {
                    this.openMenus = []
                }
                this.saveOpenMenus()
            } else {
                this.openMenus = []
                this.saveOpenMenus()
            }
        },
        handleTurboNavigation() {
            // Read the current route name from the meta tag (set by Laravel)
            const metaTag = document.querySelector('meta[name="current-route-name"]')
            if (metaTag) {
                const newRoute = metaTag.getAttribute('content')
                if (newRoute && newRoute !== this.currentRoute) {
                    this.currentRoute = newRoute
                    // updateActiveMenu will be called automatically by the watcher
                }
            }
            // Always re-apply layout classes to the new #page-container after navigation
            this.updatePageContainerClasses()
        },
        saveOpenMenus() {
            if (window.localStorage) {
                localStorage.setItem('sidebar_open_menus', JSON.stringify(this.openMenus))
            }
        },
        restoreOpenMenus() {
            if (window.localStorage) {
                const saved = localStorage.getItem('sidebar_open_menus')
                if (saved) {
                    try {
                        this.openMenus = JSON.parse(saved)
                    } catch (e) {
                        this.openMenus = []
                    }
                }
            }
        },
        load_page() {
            const getUrl = window.location
            const baseUrl = getUrl.protocol + '//' + getUrl.host
            window.location.href = baseUrl + '/back-office'
        },
        openMobileSidebar() {
            this.isOpen = true
        },
        closeMobileSidebar() {
            this.isOpen = false
            EventBus.$emit('mobile-close-sidebar')
        },
        handleResize() {
            const width = window.innerWidth
            const forceMinimized = this.minimized === true || this.minimized === 'true'

            // Update mobile flag
            this.isMobile = width <= 768

            if (this.isMobile) {
                // On mobile: always closed by default, no minimized state
                if (!this.isOpen) {
                    this.isOpen = false
                }
                this.updatePageContainerClasses()
                return
            }

            // Always minimized for small screens and 13" screens or less (width <= 1470px) or if forced
            if (width <= 1470 || forceMinimized) {
                this.isOpen = false
            } else {
                // For larger screens, we only force it open if it was closed due to a previous resize to small screen
                // or if it's the initial load. If the user manually closed it on a large screen, we should respect that.
                if (!this.isOpen && !forceMinimized && !this.resizeSideBar) {
                    this.isOpen = true
                }
            }
            this.updatePageContainerClasses()
        },
        handleHelp() {
            let url = ''
            let target = '_self'
            const getUrl = window.location
            const baseUrl = getUrl.protocol + '//' + getUrl.host
            url = baseUrl + '/back-office/helpdesk'

            if (url) {
                window.open(url, target, 'noopener,noreferrer')
            }
        },
    },
    components: {
        PanelLeftClose,
        PanelLeftOpen,
        ChartLine,
        CalendarDays,
        Computer,
        ShoppingCart,
        Megaphone,
        Settings,
        ChevronRight,
        Users,
        ChartNoAxesCombined,
        X,
        HelpCircle,
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize() // check once on mount
        // Always update the active menu based on current route
        // This ensures the parent menu stays open when navigating to a submenu
        this.updateActiveMenu()

        // Listen for Turbo navigation events to update the active route
        // Since sidebar uses data-turbo-permanent, we need to manually update currentRoute
        document.addEventListener('turbo:load', this.handleTurboNavigation)
        document.addEventListener('turbo:render', this.handleTurboNavigation)

        // Mobile sidebar open trigger from Header
        EventBus.$on('mobile-open-sidebar', this.openMobileSidebar)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        document.removeEventListener('turbo:load', this.handleTurboNavigation)
        document.removeEventListener('turbo:render', this.handleTurboNavigation)
        EventBus.$off('search-updated', this.handleSearch)
        EventBus.$off('mobile-open-sidebar', this.openMobileSidebar)
    },
}
</script>

<style scoped>
/* ============================================================
   MOBILE DRAWER OVERLAY
   ============================================================ */
.mobile-sidebar-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1032;
    cursor: pointer;
}

.mobile-drawer {
    position: fixed !important;
    top: 0;
    left: 0;
    height: 100vh !important;
    width: 300px !important;
    max-width: 85vw;
    z-index: 10001;
    transform: translateX(-100%);
    transition: transform 0.28s ease;
    overflow-y: auto;
    border-radius: 0 !important;
}

.mobile-drawer-open {
    transform: translateX(0) !important;
}

.mobile-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.12);
    cursor: pointer;
    transition: background 0.2s;
    margin-left: auto;
}

.mobile-close-btn:hover {
    background: rgba(255, 255, 255, 0.22);
}

/* ============================================================
   EXISTING DESKTOP STYLES
   ============================================================ */
#sidebar1.transitioning .expand-btn {
    opacity: 0 !important;
    pointer-events: none;
}

.logo-mini {
    transition:
        opacity 0.25s ease-in-out,
        display 0s linear 0.25s;
}

/* Styles pour le menu réduit */
.sidebar-minimized ul.nav-main-submenu {
    position: fixed; /* Bypasses overflow: hidden on parents */
    left: 110px;
    display: none;
    z-index: 9999 !important;
    background-color: #0c123aee !important;
    border-radius: 8px;
    min-width: 180px;
    max-height: 80vh;
    overflow-y: auto;
    /* top is set dynamically via :style */
    transform: none;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.sidebar-minimized ul.nav-main-submenu::before,
.sidebar-minimized .nav-main-submenu li a::before {
    display: none;
}

.sidebar-minimized ul.nav-main-submenu li:last-child {
    margin-bottom: 8px !important;
}

.sidebar-minimized ul.nav-main-submenu li {
    margin-left: 8px !important;
    margin-right: 8px !important;
}

.sidebar-minimized .nav-text {
    display: none;
}

.sidebar-minimized .nav-main-submenu .nav-text {
    display: block;
}

.sidebar-minimized .nav-main-link-submenu .openMe {
    display: none;
}

.sidebar-minimized .nav-content {
    justify-content: center;
}

.sidebar-minimized .nav-main-link {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}

/* Styles de base */
.nav-content {
    display: flex;
    align-items: center;
    gap: 20px;
}

.nav-text {
    transition: opacity 0.3s ease;
    line-height: 1.2;
}

.logo-normal,
.logo-mini {
    transition: opacity 0.3s ease;
}

/* Styles pour le bouton expand */
.expand-btn {
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
}

/* Position du bouton quand le menu est réduit (même position que le logo mini) */
.expand-btn.logo-position {
    display: none;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
}

/* Bouton visible quand nécessaire */
.expand-btn.visible {
    opacity: 1;
    display: block;
    transition: transform 0.3s ease;
}

/* Quand le menu est ouvert, le bouton est toujours à droite */
.expand-btn.position-absolute.ppv2-right-0 {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.3s ease;
}

/* Assurer que le conteneur header a une hauteur fixe pour le hover */
#contentheader1 {
    min-height: 80px;
    position: relative;
}

/* Animation pour la flèche */
.rotateArrow {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

/* Ajustements pour les sous-menus */
.nav-main-submenu {
    transition: all 0.3s ease;
}

/* Show submenu when parent li has .opens class (set by toogleSubMenu) */
.sidebar-minimized .nav-main-item.opens ul.nav-main-submenu {
    display: block;
}

.sidebar-minimized .nav-main-item {
    justify-content: center;
    align-items: center;
}

.nav-main-submenu {
    position: relative;
    margin-left: 28px;
    /* espace entre icône et ligne */
    padding-left: 12px;
    /* décalage du texte */
}

ul.nav-main-submenu::before {
    content: '';
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    height: calc(100% - 33px);
    display: flex;
    position: absolute;
    left: 30px;
    top: 19px;
}

/* Chaque élément du sous-menu */
.nav-main-submenu li {
    position: relative;
    padding: 6px 0 6px 16px;
    color: rgba(255, 255, 255, 0.8);
    transition:
        color 0.3s,
        background 0.3s;
}

/* Le point (pastille) à gauche du texte */
.nav-main-submenu li a::before {
    content: '';
    position: absolute;
    left: 26px;
    top: 52%;
    transform: translateY(-50%);
    width: 9px;
    height: 9px;
    background: transparent;
    border: none;
    border-radius: 50%;
    transition: all 0.3s ease;
}

/* Lien actif ou survolé */
.nav-main-submenu li a.active,
.nav-main-submenu li a:hover {
    color: #fff;
    font-weight: 500;
}

/* Point actif (rempli et blanc) */
.nav-main-submenu li a.active::before,
.nav-main-submenu li a:hover::before {
    background: #fff;
    border-color: #fff;
}

/* Pour l’élément actif : fond légèrement arrondi */
.nav-main-submenu li a.active {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 6px 10px;
    display: inline-block;
}

/* Transition douce */
.nav-main-submenu li,
.nav-main-submenu li::before {
    transition: all 0.3s ease;
}

/* ============================================================
   SUPPORT FOOTER
   ============================================================ */
.sidebar-footer {
    margin-top: auto;
    border-top: 1px solid rgba(255, 255, 255, 0.14);
    padding: 12px 12px 8px;
}

.sidebar-help {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 10px 12px;
    border-radius: 12px;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s ease;
}

.sidebar-help:hover {
    background: rgba(255, 255, 255, 0.09);
}

.sidebar-help-text {
    font-family: 'Poppins Regular', sans-serif;
    font-size: 13px;
    line-height: 1.2;
    white-space: nowrap;
}

.sidebar-version {
    margin-top: 8px;
    font-size: 11px;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.45);
    text-align: left;
    padding: 2px 14px 0px;
}

/* Menu réduit : seule l'icône apparaît, mêmes marges que les autres items */
.sidebar-footer-minimized {
    padding: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.14);
}

.sidebar-footer-minimized .sidebar-help {
    justify-content: center;
    padding: 12px 0;
}
</style>
